import React, { Fragment } from 'react'

// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'

// icons
import {
    faLayerGroup,
    faPercent,
    faPlus,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// router
import { withRouter } from 'react-router-dom'

import Header from '../Header/Header'
import useDepartment from './hooks/useDepartment'

function AddDepartamento({ history }) {
    const { formikCreate } = useDepartment(history)

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faLayerGroup} title={'Departamentos'} />
                </div>

                <div className="bg-gris p-4">
                    <form onSubmit={formikCreate.handleSubmit}>
                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label htmlFor="inputCodigo">Codigo</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faPercent} />
                                    </span>
                                    <input
                                        type="number"
                                        id="inputCodigo"
                                        step="any"
                                        name="codigo"
                                        className="form-control"
                                        placeholder="1"
                                        value={formikCreate.values.codigo}
                                        onChange={formikCreate.handleChange}
                                        onBlur={formikCreate.handleBlur}
                                    />
                                </div>
                                {formikCreate.touched.codigo &&
                                formikCreate.errors.codigo ? (
                                    <small className="form-text text-danger">
                                        {formikCreate.errors.codigo}
                                    </small>
                                ) : null}
                            </div>
                            <div className="form-group col-md-4">
                                <label htmlFor="inputNombre">Nombre</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faLayerGroup} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputNombre"
                                        name="nombre"
                                        className="form-control"
                                        placeholder="Ej. Lacteos, Gaseosas..."
                                        value={formikCreate.values.nombre}
                                        onChange={formikCreate.handleChange}
                                        onBlur={formikCreate.handleBlur}
                                    />
                                </div>
                                {formikCreate.touched.nombre &&
                                formikCreate.errors.nombre ? (
                                    <small className="form-text text-danger">
                                        {formikCreate.errors.nombre}
                                    </small>
                                ) : null}
                            </div>
                            <div className="form-group col-md-4">
                                <label htmlFor="inputIva">Tasa IVA</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faPercent} />
                                    </span>
                                    <input
                                        type="number"
                                        id="inputIva"
                                        step="any"
                                        min="0"
                                        name="tasaIva"
                                        className="form-control"
                                        placeholder="Ej. %21.0"
                                        value={formikCreate.values.tasaIva}
                                        onChange={formikCreate.handleChange}
                                        onBlur={formikCreate.handleBlur}
                                    />
                                </div>
                                {formikCreate.touched.tasaIva &&
                                formikCreate.errors.tasaIva ? (
                                    <small className="form-text text-danger">
                                        {formikCreate.errors.tasaIva}
                                    </small>
                                ) : null}
                            </div>
                        </div>

                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn btn-outline-success"
                            >
                                <FontAwesomeIcon icon={faPlus} /> Crear
                                Departamento
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(AddDepartamento)
